// extracted by mini-css-extract-plugin
export default {"feedback":"search_result_decision-module__feedback--2qjEO","gradient":"search_result_decision-module__gradient--3FXjZ","wrapper":"search_result_decision-module__wrapper--1g4iF"};